import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';

export const City = ({ required, id, model, label, ...props }) => {
  return (
    <React.Fragment>
      <TextInput
        model={model}
        label={label}
        formatter={(value) => {
          return value.replace(/[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?0-9]/g, '');
        }}
        validators={{
          required: required ? 'City is required.' : '',
          invalid: (value) => {
            return !value.match(/[[a-zA-Z\]]/g)
              ? 'Please enter a valid city name.'
              : '';
          },
        }}
        data-testid="primary-servicing-address-city"
        maxLength={80}
        isClearable
        name={`${model}-input-${uniqueId()}`}
        autoComplete="none"
      />
    </React.Fragment>
  );
};

City.propTypes = {
  required: PropTypes.bool,
  id: PropTypes.string,
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
};

City.defaultProps = {
  required: false,
  id: 'address-city-input',
  label: 'City',
};
